import React, {useState, useEffect} from 'react'

import { Box } from '@mui/system'
import { TextField, Button, Typography } from '@mui/material'
import Sidebar from './sidebar'
import { DataGrid } from '@mui/x-data-grid'
import { db } from '../firebase'
import dayjs from 'dayjs'


import { collection, query, getDocs } from "firebase/firestore"; 

import { useNavigate } from 'react-router-dom'
import CustomToolbar from './CustomToolbarPrint'
import ProjectFilter from './ProjectFilter'
import { matchesDailyProject } from '../utils/reportUtils'
import { Summarize } from '@mui/icons-material'

export default function Services() {
    const [date1, setdate1] = useState("")
    const [date2, setdate2] = useState("")
    const [projectFilter, setprojectFilter] = useState([])
    const [rows, setRows] = useState([])
    const [rows1, setRows1] = useState([])

    const handleProjects = (projects) => {
      setprojectFilter(projects)
      setRows([])
      setRows1([])
    }

  async function getData (){
    console.log("me chala")
    if (projectFilter.length === 0) {
      setRows([])
      setRows1([])
      return
    }
    let arr = []
    let arr1 = []
    let sum ={
      id: Date.now(),
      meals:0,
      showers:0,
      male:0,
      female:0,
      others:0,
      probaition: 0,
      nonClientFood: 0,
      outreachSupport: 0,
      tentsIssued: 0,
      homeless: 0,
      mosesStarter: 0,
      miriamStarter: 0,
      buddyStarter: 0,
      mosesFood: 0,
      miriamFood: 0,
      buddyFood: 0,
      sleepingBags: 0

    }
    const q = query(collection(db, "dailySumbissions"));
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
      let obj = doc.data();
      Object.assign(obj, {doc: doc.id});
      console.log(obj)
      
      if(dateCheck(date1,date2,obj.date) && matchesDailyProject(obj, projectFilter)){
        arr.push(obj)
        sum.meals = parseInt(sum.meals) + (parseInt(obj.meals) || 0)
        sum.showers = parseInt(sum.showers) + (parseInt(obj.showers) || 0)
        sum.male = parseInt(sum.male) + (parseInt(obj.male) || 0)
        sum.female = parseInt(sum.female) + (parseInt(obj.female) || 0)
        sum.others = parseInt(sum.others) + (parseInt(obj.others) || 0)
        sum.probaition = parseInt(sum.probaition) + (parseInt(obj.probaition) || 0)
        sum.nonClientFood = parseInt(sum.nonClientFood) + (parseInt(obj.nonClientFood) || 0)
        sum.outreachSupport = parseInt(sum.outreachSupport) + (parseInt(obj.outreachSupport) || 0)
        sum.tentsIssued = parseInt(sum.tentsIssued) + (parseInt(obj.tentsIssued) || 0)
        sum.homeless = parseInt(sum.homeless) + (parseInt(obj.homeless) || 0)
        sum.mosesStarter = parseInt(sum.mosesStarter) + (parseInt(obj.mosesStarter) || 0)
        sum.miriamStarter = parseInt(sum.miriamStarter) + (parseInt(obj.miriamStarter) || 0)
        sum.buddyStarter = parseInt(sum.buddyStarter) + (parseInt(obj.buddyStarter) || 0)
        sum.mosesFood = parseInt(sum.mosesFood) + (parseInt(obj.mosesFood) || 0)
        sum.miriamFood = parseInt(sum.miriamFood) + (parseInt(obj.miriamFood) || 0)
        sum.buddyFood = parseInt(sum.buddyFood) + (parseInt(obj.buddyFood) || 0)
        sum.sleepingBags = parseInt(sum.sleepingBags) + (parseInt(obj.sleepingBags) || 0)
      }
      
      else{
        
      }
      
     });
     arr1.push(sum)
     setRows(arr)
     setRows1(arr1)
    
  }


 

function dateCheck(from,to,check) {

    var fDate,lDate,cDate;
    fDate = Date.parse(from);
    lDate = Date.parse(to);
    cDate = Date.parse(check);

    if((cDate <= lDate && cDate >= fDate)) {
        return true;
    }
    return false;
}


    const navigate = useNavigate();
    const columns = [
      { field: 'date', headerName: 'Date' , width: 150 ,
      valueFormatter: (params) => dayjs(params.value).format('DD/MM/YYYY')},
        { field: 'mosesStarter', headerName: 'Moses Starter Packs' , width: 140 },
        { field: 'miriamStarter', headerName: 'Miriam Starter Packs' , width: 140 },
        { field: 'buddyStarter', headerName: 'Buddy Starter Packs' , width: 140 },
        { field: 'mosesFood', headerName: 'Moses Food Parcels' , width: 140 },
        { field: 'miriamFood', headerName: 'Miriam Food Parcels' , width: 140 },
        { field: 'buddyFood', headerName: 'Buddy Food Parcels' , width: 140 },
        { field: 'nonClientFood', headerName: 'Non-Client Food Parcels' , width: 150 },
        { field: 'male', headerName: 'Male' , width: 90 },
        { field: 'female', headerName: 'Female' , width: 90 },
        { field: 'others', headerName: 'Other Genders' , width: 120 },
        { field: 'total', headerName: 'Total' , width: 90 ,
          valueGetter: (params) => (parseInt(params.row.male) || 0) + (parseInt(params.row.female) || 0) + (parseInt(params.row.others) || 0) },
        { field: 'outreachSupport', headerName: 'Outreach Support (None Clients)' , width: 190 },
        { field: 'probaition', headerName: 'Attendees on Probation' , width: 170 },
        { field: 'homeless', headerName: 'Homeless Attendees' , width: 150 },
        { field: 'meals', headerName: 'Hot Meals Provided', width: 140 },
        { field: 'showers', headerName: 'Showers Provided', width: 140 },
        { field: 'sleepingBags', headerName: 'Sleeping Bags' , width: 130 },
        { field: 'tentsIssued', headerName: 'Tents Issued' , width: 130 },
        { field: 'name', headerName: 'Submitted By' , width: 150 },

    ];
    
    const columns1 = [
        { field: 'mosesStarter', headerName: 'Moses Starter Packs', width: 150 },
        { field: 'miriamStarter', headerName: 'Miriam Starter Packs', width: 150 },
        { field: 'buddyStarter', headerName: 'Buddy Starter Packs', width: 150 },
        { field: 'mosesFood', headerName: 'Moses Food Parcels', width: 150 },
        { field: 'miriamFood', headerName: 'Miriam Food Parcels', width: 150 },
        { field: 'buddyFood', headerName: 'Buddy Food Parcels', width: 150 },
        { field: 'nonClientFood', headerName: 'Non-Client Food Parcels', width: 160 },
        { field: 'male', headerName: 'Male' , width: 100 },
        { field: 'female', headerName: 'Female' , width: 100 },
        { field: 'others', headerName: 'Other Genders' , width: 130 },
        { field: 'total', headerName: 'Total' , width: 100 ,
          valueGetter: (params) => (parseInt(params.row.male) || 0) + (parseInt(params.row.female) || 0) + (parseInt(params.row.others) || 0) },
        { field: 'outreachSupport', headerName: 'Outreach Support (None Clients)', width: 190 },
        { field: 'probaition', headerName: 'Attendees on Probation' , width: 170 },
        { field: 'homeless', headerName: 'Homeless Attendees', width: 150 },
        { field: 'meals', headerName: 'Hot Meals Provided', width: 120 },
        { field: 'showers', headerName: 'Showers Provided', width: 120 },
        { field: 'sleepingBags', headerName: 'Sleeping Bags' , width: 130 },
        { field: 'tentsIssued', headerName: 'Tents Issued' , width: 120 },

    ];
  
    const handleRowClick = (params) => {
      navigate("/profileStaff",{
        state: {
          employee: params.row,
        }
      });
    };

  return (
    <Box sx={{ display: 'flex' }}>
    <Sidebar />


    <Box component="main" sx={{ flexGrow: 1, p: 3 }} style={{ marginTop: "50px", justifyContent: "center", alignItems: "center" }}>

      <div style={{ width: '100%' }}>
      <ProjectFilter value={projectFilter} onChange={handleProjects} />
      <TextField type="date" InputLabelProps={{ shrink: true, }} className='addform' id="outlined-basic" label="Start Date" variant="outlined" style={{ width: "45%" }} onChange={(e) => setdate1(e.target.value)} value={date1} />
      <TextField type="date" InputLabelProps={{ shrink: true, }} className='addform' id="outlined-basic" label="End Date" variant="outlined" style={{ width: "45%" }} onChange={(e) => setdate2(e.target.value)} value={date2} />
      <Button onClick={getData} disabled={projectFilter.length === 0} className='addform' variant="contained" style={{ marginBottom: "10px", width: "100%", height: "50px", marginTop: "30px", backgroundColor: "#F21D2F" }}>Search</Button>

      <Typography variant="h6" sx={{ mt: 2, mb: 1 }}>Overall Summary</Typography>
      <div style={{ height: "35vh", marginBottom: "20px" }}>
      <DataGrid 
                
                rows={rows1}
                columns={columns1}
                pageSize={1}
                rowsPerPageOptions={[1]}
                components={{
                  Toolbar: CustomToolbar,
                }}
            />
      </div>

      <Typography variant="h6" sx={{ mb: 1 }}>Daily Breakdown</Typography>
      <div style={{ height: 440 }}>
      <DataGrid 
                
                  rows={rows}
                  columns={columns}
                  pageSize={10}
                  rowsPerPageOptions={[5]}
                  //checkboxSelection
                 // onRowDoubleClick={handleRowClick}
                  components={{
                    Toolbar: CustomToolbar,
                  }}
              />
      </div>
    
    </div>
    </Box>
    </Box>
  )
}
